import {RoomActivity} from '@lib/store';
import {TFunction} from 'i18next';
import {constructFilter} from './constructFilter';

export const SECTION_ID_ROOM_ACTIVITY_TYPE = 'SECTION_ID_ROOM_ACTIVITY_TYPE';

export const constructRoomActivityTypeFilter = <TEntity extends {activities: RoomActivity[]}>(
  availableActivityTypes: RoomActivity[],
  t: TFunction,
) => {
  return constructFilter({
    sectionId: SECTION_ID_ROOM_ACTIVITY_TYPE,
    sectionTitle: t('meeting:SuitsForTitle'),
    type: 'and',
    data: availableActivityTypes.map((id) => ({
      id,
      label: t(`meetingCharacteristic:${id}`),
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.activities.includes(filter.id),
  });
};
